import {
  NgModule
} from '@angular/core';
import {
  CommonModule
} from '@angular/common';
import * as Highcharts from 'highcharts';
import { ProjConstants } from 'src/app/utils/proj.constant';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class ConstantsModule {

  MILLIS_IN_A_DAY = 24 * 60 * 60 * 1000;
  DEBUGGER = false;
  EVENTGEN_YEAR = 'yyyy';
  EVENTGEN_MONTH = 'yyyyMM';
  EVENTGEN_DAY = 'yyyyMMdd';
  EVENTGEN_HOURLY = 'HOURLY';
  KERALA_AREA = 38863;
  mmToKm = 0.000001;
  cubicKmToTMC = 35.314666721;
  McmToTMC = 28.31684;

  DEFAULT_STATE = ProjConstants.STATENAME;
  KERALA_UUID = ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'];
  ANDHRA_PRADESH_UUID = ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'];
  COUNTRY_UUID = ProjConstants.STATETOUUIDMAPPING['COUNTRY'];
  KERALA = ProjConstants.STATENAME;
  ANDHRA_PRADESH = 'ANDHRA PRADESH';
  KERALA_SW = 'Kerala SW';

  SOURCES = {
    CWC: 'CWC',
    IMD: 'IMD',
    KERALA_SW: 'Kerala SW',
    STATE_AND_CENTRAL_STATION: 'STATE_AND_CENTRAL_STATION',
    IMD_GRID: 'IMD GRID',
    IMD_1: 'IMD_1',
    GPM_GRID: 'GPM GRID',
    IDRB: 'IDRB',
    KSEB: 'KSEB',
    KWA: 'KWA',
    CGWB: 'CGWB',
    NRSC: 'NRSC',
    IMD_05: 'IMD_05'
  };

  GPM_GRID = 'GPM GRID';
  CWC = 'CWC';
  IMD = 'IMD';
  IDRB = 'IDRB';
  IMD_GRID = 'IMD GRID';
  IMD_STATIONS = 'IMD_STATIONS';
  AP_AWS = 'AP_AWS';
  IMD_1 = 'IMD_1';
  STATE_STATIONS = 'STATE_STATIONS';
  // IMD_1 = "IMD Grid 1 deg"
  LOW = 'LOW';
  MED = 'MED';
  HIGH = 'HIGH';
  ADMIN = 'ADMIN';
  BASIN = 'BASIN';

  COMPONENT = {
    RAINFALL: 'rainfall',
    RAINFALLACTUAL: 'rainfall-actual',
    RESERVOIR: 'reservoir',
    RIVERPOINT: 'River Authority',
    DROUGHT: 'drought',
    GROUNDWATER: 'groundwater',
    EVAPOTRANSPIRATION: 'et',
    SOILMOISTURE: 'soilmoisture',
    GWATERQUALITY: 'groundwater_wq',
    SWATERQUALITY: 'surfacewater_wq',
    WATERAUDIT: 'wateraudit',
    CONTENT_MANAGEMENT: 'contentmanagement',
    MOBILE_APP_REGISTRATION: 'mobileappregistration',
    MI_TANKS: 'mitank',
    MI_PONDS: 'miponds',
    SURFACEWATER: 'surfacewater',
    WCSTRUCTURE: 'wcstructure',
    TEMPERATURE: 'temperature',
    RIVER_POINT: 'riverpoint',
    HUMIDITY: 'humidity',
    WINDSPEED: 'wind',
    LISCHEMES: 'lischemes',
    WC_STRUCTURES: 'WC_STRUCTURE' //Latest
  };

  ACTUAL_COMPONENT = {
    RAINFALL : 'RAINFALL',
    WINDSPEED : 'WINDSPEED',
    TEMPERATURE : 'TEMPERATURE',
    HUMIDITY : 'HUMIDITY'
  }

  COMPONENTFORROUTING = {
    RAINFALL: 'rainfall',
    RAINFALLACTUAL: 'rainfall-actual',
    WINDSPEEDACTUAL: 'windspeed-actual',
    RESERVOIR: 'reservoir',
    RIVERPOINT: 'River Authority',
    RIVER_POINT: 'riverpoint',
    RIVERPOINTS: 'river-points',
    GROUNDWATER: 'ground-water',
    GROUND_WATER: 'groundwater',
    EVAPOTRANSPIRATION: 'et',
    SOILMOISTURE: 'soilmoisture',
    SOIL_MOISTURE: 'soilmoisture',
    GWATERQUALITY: 'groundwater_wq',
    SWATERQUALITY: 'surfacewater_wq',
    CONTENT_MANAGEMENT: 'contentmanagement',
    MOBILE_APP_REGISTRATION: 'mobileappregistration',
    MI_TANKS: 'mitank',
    MI_PONDS: 'mi-ponds',
    SURFACEWATER: 'surfacewater',
    WCSTRUCTURE: 'wcstructure',
    TEMPERATURE: 'temperature',
    HUMIDITY: 'humidity',
    WINDSPEED: 'wind',
    LISCHEMES: 'li-schemes',
    RAINFALLFORECAST: 'rainfall-forecast',
    TEMPERATUREFORECAST: 'temperature-forecast',
    HUMIDITYFORECAST: 'humidity-forecast',
    WINDSPEEDFORECAST: 'wind-speed-forecast',
    RESERVOIRACTUAL: 'reservoir-actual',
    RESERVOIRFORECAST: 'reservoir-forecast',
    GROUNDWATERQUALITY: 'gw_quality',
    SURFACEWATERQUALITY: 'sw_quality',
    AGRICULTURE: 'agriculture',
    DOMESTIC: 'domestic',
    INDUSTRY: 'industry',
    HYDRO_POWER: 'hydro-power',
    INLAND: 'inland',
    BASIN_LEVEL_WATER_BUDGET: 'basin_level_wb',
    PANCHYATH_LEVEL_WATER_BUDGET: 'panchayat_level_wb',
    WATERAUDIT: 'water_audit',
    WEATHER_DATA: 'Weather Data',
    WATER_RESOURCE_INFORMATION: 'Water Resource Information',
    WATER_RESOURCE_MANAGEMENT: 'Water Resource Management'
  };

  MODULE_FOR_ROUTES = {

    BASE_ROUTE_FOR_MIS: 'mis',

    //Water Resource Management
    BASIN_LEVEL_WATER_BUDGET: 'basin_level_wb',
    PANCHYATH_LEVEL_WATER_BUDGET: 'panchayat_level_wb',
    WATERAUDIT: 'water_audit',


    //Water Availability
    RESERVOIR: 'reservoir-actual',
    MI_PONDS: 'mi-ponds',
    WC_STRUCTURES: 'wc-structures',
    LI_SCHEMES: 'li-schemes',
    SOIL_MOISTURE: 'soil-moisture',
    RIVER_POINTS: 'river-points',
    GROUND_WATER: 'ground-water',
    SURFACE_WATER_QUALITY: 'sw_quality',
    GROUND_WATER_QUALITY: 'gw_quality',


    //Water Demand
    AGRICULTURE: 'agriculture',
    DOMESTIC: 'domestic',
    INDUSTRY: 'industry',
    HYDRO_POWER: 'hydro-power',
    INLAND: 'inland',


    //Weather Data
    RAINFALL: 'rainfall-actual',
    HUMIDITY: 'humidity',
    TEMPERATURE: 'temperature',
    WINDSPEED: 'wind-speed',

    //Home Routes For Dashboards
    WEATHER_DATA_HOME: 'wd/home',
    WATER_RESOURCE_MANAGEMENT_HOME: 'wrm/home',
    WATER_AVAILABLITY_HOME: 'wa-home',
    WATER_DEMAND_HOME: 'water-demand-home',
    WATER_RESOURCE_INFORMATION_HOME: 'wri',
    WATER_RESOURCE_INFORMATION_HOME_WITH_WA: 'wri/wa-home',
    WATER_RESOURCE_INFORMATION_HOME_WITH_WD: 'wri/water-demand-home'

  };


  LOCATION_TYPES = ['country', 'state', 'district', 'BLOCK', 'block', 'village', 'basin', 'subbasin'];

  //Bottom to Up Spatially
  SORTED_DISTRICT_LIST = [{ 'locationName': 'Thiruvananthapuram', 'locationUUID': '787d19b3-b511-4161-b08c-aa23082318be' }, { 'locationName': 'Kollam', 'locationUUID': '19bf47d8-4ba3-42ff-9dea-f1581c9d7ab7' }, { 'locationName': 'Pathanamthitta', 'locationUUID': '273d765a-fc5f-417a-bee8-a4257f271ca6' }, { 'locationName': 'Alappuzha', 'locationUUID': '46d05795-d880-42fb-824a-4c9ec61034a2' }, { 'locationName': 'Kottayam', 'locationUUID': '93bf1cb2-38d6-404c-8c21-a7beeec5c644' }, { 'locationName': 'Idukki', 'locationUUID': '97ace365-2913-4b3d-8682-e796acfdc689' }, { 'locationName': 'Ernakulam', 'locationUUID': '3915d00f-2e7d-47e0-9113-f3824b61daae' }, { 'locationName': 'Thrissur', 'locationUUID': 'f81337dc-d04d-4618-9714-3609fe891919' }, { 'locationName': 'Palakkad', 'locationUUID': '1270f554-20cc-43ee-803e-1532f00e047c' }, { 'locationName': 'Malappuram', 'locationUUID': '10c9393d-79e0-4670-816a-8a05b395b13e' }, { 'locationName': 'Kozhikode', 'locationUUID': '8189474d-71b9-488c-b45a-34bbcda95308' }, { 'locationName': 'Wayanad', 'locationUUID': '9638dab0-6fbe-4b7c-9f13-8908cc768221' }, { 'locationName': 'Mahe', 'locationUUID': '0d2a8063-c944-4b01-a5e5-9401cc32cddf' }, { 'locationName': 'Kannur', 'locationUUID': '02122ce9-dea4-4840-8745-5d3743e087a7' }, { 'locationName': 'Kasaragod', 'locationUUID': '4a0e14b2-de3e-4a7b-b1a4-a39e66ddbe48' }];

  AGGR_TYPES = {
    SUM: 'SUM',
    MIN: 'MIN',
    MAX: 'MAX',
    AVG: 'AVG',
    LATEST: 'LATEST',
    DEFAULT: 'DEFAULT'
  };

  DATEPICKER_DATE_FORMAT = {
    YEAR: 'yyyy',
    MONTH: 'yyyyMM',
    DAY: 'yyyyMMdd',
    SEASON: 'season',
    HOURLY: 'HOURLY',
    DAILY: 'DAILY'
  };

  DATEPICKER_DATE = {
    Yearly: 'yyyy',
    Monthly: 'yyyyMM',
    Daily: 'yyyyMMdd',
    Hourly: 'HOURLY'
  };

  DATEPICKER_DATES = {
    Yearly: 'yyyy',
    Monthly: 'yyyyMM',
    Daily: 'yyyyMMdd',
  };

  DATE_FORMAT = {
    [this.DATEPICKER_DATE_FORMAT.YEAR]: 'Yearly',
    [this.DATEPICKER_DATE_FORMAT.MONTH]: 'Monthly',
    [this.DATEPICKER_DATE_FORMAT.DAY]: 'Daily',
    [this.DATEPICKER_DATE_FORMAT.SEASON]: 'Season',
    [this.DATEPICKER_DATE_FORMAT.HOURLY]: 'HOURLY',
  };

  DATE_FORMAT_NEW = {
    [this.DATEPICKER_DATE_FORMAT.YEAR]: 'YEARLY',
    [this.DATEPICKER_DATE_FORMAT.MONTH]: 'MONTHLY',
    [this.DATEPICKER_DATE_FORMAT.DAY]: 'DAILY',
    [this.DATEPICKER_DATE_FORMAT.SEASON]: 'SEASON',
    [this.DATEPICKER_DATE_FORMAT.HOURLY]: 'HOURLY'
  };

  CLASSIFICATION_TYPES = {
    ACTUAL: 'ACTUAL',
    NORMAL: 'NORMAL',
    DEVIATION: 'DEVIATION',
    MAX: 'MAX',
    MIN: 'MIN',
    MEAN: 'MEAN'
  };

  VIEWS = {
    ADMIN: 'ADMIN',
    BASIN: 'BASIN',
    REGION: 'REGION',
    RIVER: 'RIVER'
  };
  LOCATION_CONSTANT = {
    COUNTRY: 'COUNTRY',
    STATE: 'STATE',
    DISTRICT: 'DISTRICT',
    BLOCK: 'BLOCK',
    VILLAGE: 'VILLAGE',
    ULB: 'ULB',
    MANDAL: 'MANDAL',
    PANCHAYATH: 'PANCHAYATH',
    BASIN: 'BASIN',
    SUBBASIN: 'SUBBASIN',
    STATION: 'STATION',
    RESERVOIR: 'RESERVOIR',
    MI_TANKS: 'Minor Irrigation Tanks',
    RIVERPOINT: 'River Authority',
    GROUNDWATER: 'Ground Water',
    REGION: 'REGION',
    RIVER: 'RIVER',
    WC_STRUCTURE: 'Wc Structure',
    RAINFALL: 'RAINFALL'
  };
  WC_STRUCTURE: 'Wc Structure';
  // Used for displaying info on Infobox and Map Title
  SELECTED_COMPONENT_CORRESPONDING_DATA = {
    SOURCE: '',
    MIN_DATE: '',
    MAX_DATE: '',
    // For Seasonal
    sDate: '',
    eDate: ''
  };

  LOCATION_LEVEL = {
    [this.VIEWS.ADMIN]: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT,
    this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION
    ],
    [this.VIEWS.BASIN]: []
  };

  ADMIN_PARENT_CHILD_MAP = {
    // [this.LOCATION_CONSTANT.COUNTRY]:this.LOCATION_CONSTANT.STATE,
    [this.LOCATION_CONSTANT.STATE]: this.LOCATION_CONSTANT.DISTRICT,
    [this.LOCATION_CONSTANT.DISTRICT]: this.LOCATION_CONSTANT.PANCHAYATH
  };

  LOCATION_PARENT_CHILD_MAP = {
    // [this.LOCATION_CONSTANT.COUNTRY]:this.LOCATION_CONSTANT.STATE,
    [this.LOCATION_CONSTANT.STATE]: this.LOCATION_CONSTANT.DISTRICT,
    [this.LOCATION_CONSTANT.DISTRICT]: this.LOCATION_CONSTANT.MANDAL
  };

  BASIN_PARENT_CHILD_MAP = {
    // [this.LOCATION_CONSTANT.COUNTRY]:this.LOCATION_CONSTANT.STATE,
    [this.LOCATION_CONSTANT.STATE]: this.LOCATION_CONSTANT.BASIN,
    [this.LOCATION_CONSTANT.BASIN]: this.LOCATION_CONSTANT.STATION
  };

  ADMIN_PARENT_CHILD_STATION_MAP = {
    // [this.LOCATION_CONSTANT.COUNTRY]:this.LOCATION_CONSTANT.STATE,
    [this.LOCATION_CONSTANT.STATE]: this.LOCATION_CONSTANT.DISTRICT,
    [this.LOCATION_CONSTANT.DISTRICT]: this.LOCATION_CONSTANT.BLOCK,
    [this.LOCATION_CONSTANT.BLOCK]: this.LOCATION_CONSTANT.VILLAGE,
    [this.LOCATION_CONSTANT.VILLAGE]: this.LOCATION_CONSTANT.STATION,
    [this.LOCATION_CONSTANT.STATION]: this.LOCATION_CONSTANT.STATION,
    [this.LOCATION_CONSTANT.RAINFALL]: this.LOCATION_CONSTANT.RAINFALL
  };

  ACCURACY_CHILD_PARENT_MAP = {
    [this.LOCATION_CONSTANT.DISTRICT]: this.LOCATION_CONSTANT.STATE,
    [this.LOCATION_CONSTANT.BLOCK]: this.LOCATION_CONSTANT.DISTRICT,
    [this.LOCATION_CONSTANT.VILLAGE]: this.LOCATION_CONSTANT.BLOCK
  };

  BASIN_PARENT_CHILD_STATION_MAP = {
    // [this.LOCATION_CONSTANT.COUNTRY]:this.LOCATION_CONSTANT.STATE,
    [this.LOCATION_CONSTANT.STATE]: this.LOCATION_CONSTANT.BASIN,
    [this.LOCATION_CONSTANT.BASIN]: this.LOCATION_CONSTANT.STATION,
    [this.LOCATION_CONSTANT.STATION]: this.LOCATION_CONSTANT.STATION,
    [this.LOCATION_CONSTANT.RAINFALL]: this.LOCATION_CONSTANT.RAINFALL
  };

  CHILD_TO_PARENT_LOCATION_MAP = {
    [this.LOCATION_CONSTANT.DISTRICT]: this.LOCATION_CONSTANT.STATE,
    [this.LOCATION_CONSTANT.BLOCK]: this.LOCATION_CONSTANT.DISTRICT,
    [this.LOCATION_CONSTANT.PANCHAYATH]: this.LOCATION_CONSTANT.BLOCK,
    [this.LOCATION_CONSTANT.STATION]: this.LOCATION_CONSTANT.PANCHAYATH,
    [this.LOCATION_CONSTANT.RAINFALL]: this.LOCATION_CONSTANT.STATE,
    [this.BASIN]: this.LOCATION_CONSTANT.STATE
  };

  // BASIN_PARENT_CHILD_MAP = {
  //   [this.LOCATION_CONSTANT.COUNTRY]:this.LOCATION_CONSTANT.BASIN,
  //   [this.LOCATION_CONSTANT.BASIN]:this.LOCATION_CONSTANT.SUBBASIN
  // };
  // BASIN_PARENT_CHILD_STATION_MAP = {
  //   [this.LOCATION_CONSTANT.COUNTRY]:this.LOCATION_CONSTANT.BASIN,
  //   [this.LOCATION_CONSTANT.BASIN]:this.LOCATION_CONSTANT.SUBBASIN,
  //   [this.LOCATION_CONSTANT.SUBBASIN]:this.LOCATION_CONSTANT.STATION,
  // };

  SOURCE = {
    IMD: 'IMD',
    ECMWF: 'ECMWF',
    IMD2: 'IMD (WRF + GFS)'
  };

  SOURCE_WISE = {
    [this.SOURCE.IMD]: {
      PrimarySourceType: 'IMD_LONG_RANGE',
      SecondarySourceType: 'IMD_LONG_RANGE',
    },
    [this.SOURCE.ECMWF]: {
      PrimarySourceType: 'ECMWF',
      SecondarySourceType: 'ECMWF',
    },
    [this.SOURCE.IMD2]: {
      PrimarySourceType: 'IMD_SHORT_RANGE',
      SecondarySourceType: 'IMD_LONG_RANGE',
    },
  };

  CYCLONE_SOURCE = {
    NOAA: 'NOAA',
    ECMWF: 'ECMWF',
    IMD:'IMD'
  };

  CYCLONE_SOURCE_WISE = {
    [this.CYCLONE_SOURCE.NOAA]: {
      PrimarySourceType: 'NOAA',
      SecondarySourceType: 'null',
    },
    [this.CYCLONE_SOURCE.ECMWF]: {
      PrimarySourceType: 'ECMWF',
      SecondarySourceType: 'null',
    },
    [this.CYCLONE_SOURCE.IMD]: {
      PrimarySourceType: 'IMD',
      SecondarySourceType: 'null',
    }
  };

  COMPONENT_SOURCE_HIERARCHY_MAP = {
    [this.COMPONENT.WCSTRUCTURE]: {
      [this.SOURCES.STATE_AND_CENTRAL_STATION]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.WC_STRUCTURE],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.STATION]
      },
    },

    [this.COMPONENT.RAINFALL]: {
      [this.KERALA_SW]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.STATION]
      },
      [this.AP_AWS]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.SOURCES.STATE_AND_CENTRAL_STATION]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.STATION]
      },
      [this.CWC]: {
        ADMIN: [this.LOCATION_CONSTANT.COUNTRY,this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.STATION]
      },
      [this.IMD]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.IMD_GRID]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.PANCHAYATH],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.GPM_GRID]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.PANCHAYATH],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.SOURCES.STATE_AND_CENTRAL_STATION]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.PANCHAYATH],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      }
    },

    [this.COMPONENT.WINDSPEED]: {
      [this.KERALA_SW]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.STATION]
      },
      [this.AP_AWS]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.SOURCES.STATE_AND_CENTRAL_STATION]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.CWC]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.IMD]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.IMD_GRID]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.GPM_GRID]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.SOURCES.STATE_AND_CENTRAL_STATION]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      }
    },

    [this.COMPONENT.TEMPERATURE]: {
      [this.IMD_1]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.AP_AWS]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.IMD_GRID]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.IMD]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.GPM_GRID]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.KERALA_SW]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.SOURCES.IMD_05]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION,],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.STATE_STATIONS]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
    },

    [this.COMPONENT.HUMIDITY]: {
      [this.KERALA_SW]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.STATION]
      },
      [this.AP_AWS]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.SOURCES.STATE_AND_CENTRAL_STATION]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.CWC]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.IMD]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.IMD_GRID]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.GPM_GRID]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.SOURCES.STATE_AND_CENTRAL_STATION]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
      [this.STATE_STATIONS]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.VILLAGE, this.LOCATION_CONSTANT.RAINFALL, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN]
      },
    },

    [this.COMPONENT.RESERVOIR]: {
      [this.KERALA_SW]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.STATION]
      },
      [this.SOURCES.STATE_AND_CENTRAL_STATION]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.STATION]
      },
      [this.SOURCES.KWA]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.STATION]
      },
      [this.SOURCES.KSEB]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.STATION]
      },
      [this.IDRB]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.STATION]
      },
      [this.CWC]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.STATION]
      }
    },

    [this.COMPONENT.RIVERPOINT]: {
      [this.SOURCES.STATE_AND_CENTRAL_STATION]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.STATION],
        RIVER: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.RIVER, this.LOCATION_CONSTANT.STATION]
      },
      [this.KERALA_SW]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.STATION],
        RIVER: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.RIVER, this.LOCATION_CONSTANT.STATION]
      },
      [this.CWC]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.STATION],
        RIVER: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.RIVER, this.LOCATION_CONSTANT.STATION]
      }
    },

    [this.COMPONENT.GROUNDWATER]: {
      [this.SOURCES.CGWB]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH, this.LOCATION_CONSTANT.STATION],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.STATION]
      },
    },

    [this.COMPONENT.SOILMOISTURE]: {
      [this.SOURCES.NRSC]: {
        ADMIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT, this.LOCATION_CONSTANT.BLOCK, this.LOCATION_CONSTANT.PANCHAYATH],
        BASIN: [this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.BASIN]
      },
    },
  };

  // To do :: Move chart constants to another module

  DEFAULT_CHART_PARAMS = {
    'rfHome': {
      'cType': 'DISTRICT',
      'lType': 'STATE',
      'lUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'aggr': 'SUM',
      'component': 'rainfall',
      'eDate': '20200515',
      'format': 'yyyyMMdd',
      'sDate': '20190601',
      'view': 'admin',
      'src': 'IMD GRID',
      'chartType': 'widget',
      'summary': false,
      'pEUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']'
    }
  };

  HOME_KPI_PARAMS = {
    'homerfKpi': {
      'cType': 'DISTRICT',
      'lType': 'STATE',
      'pUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'aggr': 'SUM',
      'component': 'rainfall',
      'eDate': '20200515',
      'format': 'yyyyMMdd',
      'sDate': '20190601',
      'pDate': '2018',
      'src': 'IMD GRID',
      'summary': true,
      'sUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']'
    }
  };

  // Rainfall chart and kpi params

  RAINFALL_DONUT_PARAMS = {
    'rfDonut': {
      'cType': 'DISTRICT',
      'lType': 'STATE',
      'lUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'aggr': 'SUM',
      'component': 'rainfall',
      'eDate': '2018',
      'format': 'yyyy',
      'sDate': '2018',
      'view': 'admin',
      'src': 'Kerala SW',
      'chartType': 'pie',
      'summary': false,
      'pEUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']'
    }
  };

  RAINFALL_TOP10_PARAMS = {
    'rfTop': {
      'cType': 'DISTRICT',
      'lType': 'STATE',
      'lUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'aggr': 'SUM',
      'component': 'rainfall',
      'eDate': '2018',
      'format': 'yyyy',
      'sDate': '20180501',
      'view': 'admin',
      'src': 'Kerala SW',
      'chartType': 'top',
      'summary': false,
      'pEUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']'
    }
  };

  RAINFALL_BOTTOM10_PARAMS = {
    'rfBottom': {
      'cType': 'DISTRICT',
      'lType': 'STATE',
      'lUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'aggr': 'SUM',
      'component': 'rainfall',
      'eDate': '2018',
      'format': 'yyyy',
      'sDate': '2018',
      'view': 'admin',
      'src': 'Kerala SW',
      'chartType': 'bottom',
      'summary': false,
      'pEUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']'
    }
  };

  RAINFALL_KPI_PARAMS = {
    'rfKpi': {
      'cType': 'DISTRICT',
      'lType': 'STATE',
      'pUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'aggr': 'SUM',
      'component': 'rainfall',
      'eDate': '2018',
      'format': 'yyyy',
      'sDate': '2018',
      'pDate': '2018',
      'src': 'Kerala SW',
      'summary': true,
      'sUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']'
    }
  };



  GROUNDWATER_KPI_PARAMS = {
    'gwKpi': {
      'pEUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'pUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'src': 'CGWB',
      'lType': 'STATE',
      'cType': 'DISTRICT',
      'format': 'season1',
      'sDate': '2018',
      'eDate': '2018'
    }
  };



  // Rainfall Forecast Params


  RAINFALL_FORECAST_TOP10_PARAMS = {
    'fcTop': {
      'cType': 'DISTRICT',
      'component': 'RAINFALL',
      'pType': 'STATE',
      'forecastLength': '24',
      'pUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'sUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'primarySource': 'IMD_SHORT_RANGE',
      'secondarySource': 'IMD_LONG_RANGE',
      'chartType': 'top',
      'view': 'Admin'
    }
  };



  RAINFALL_FORECAST_BOTTOM10_PARAMS = {
    'fcBottom': {
      'cType': 'DISTRICT',
      'component': 'RAINFALL',
      'pType': 'STATE',
      'forecastLength': '24',
      'pUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'sUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'primarySource': 'IMD_SHORT_RANGE',
      'secondarySource': 'IMD_LONG_RANGE',
      'chartType': 'bottom',
      'view': 'Admin'
    }
  };

  RESERVOIR_NORMAL_PARAMS = {
    'reservoirNormal': {
      'component': 'reservoir',
      'view': 'admin',
      'chartType': 'normal',
      'pEUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'format': 'yyyyMMdd',
      'lType': 'STATE',
      'lUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'src': 'Kerala SW',
      'sDate': '201908',
      'np': 5
    }
  };

  RESERVOIR_TOP_PARAMS = {
    'reservoirTop': {
      'component': 'reservoir',
      'view': 'admin',
      'chartType': 'top',
      'pEUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'format': 'yyyyMMdd',
      'lType': 'STATE',
      'cType': 'DISTRICT',
      'lUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'src': 'Kerala SW',
      'sDate': '20190101'
    }
  };

  RESERVOIR_BOTTOM_PARAMS = {
    'reservoirBottom': {
      'component': 'reservoir',
      'view': 'admin',
      'chartType': 'bottom',
      'pEUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'format': 'yyyyMMdd',
      'lType': 'STATE',
      'cType': 'DISTRICT',
      'lUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'src': 'Kerala SW',
      'sDate': '20190101'
    }
  };

  RESERVOIR_FUNNEL_PARAMS = {
    'reservoirFunnel': {
      'component': 'reservoir',
      'view': 'admin',
      'chartType': 'pieChart',
      'pEUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'format': 'yyyyMMdd',
      'lType': 'STATE',
      'lUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'src': 'STATE_AND_CENTRAL_STATION',
      'sDate': '20190604'
    }
  };


  GROUNDWATER_DONUT_PARAMS = {
    'gwDonut': {
      'pEUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'pUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'src': 'CGWB',
      'lType': 'STATE',
      'cType': 'STATION',
      'format': 'season1',
      'sDate': '2018',
      'eDate': '2018'
    }
  };

  // actual to short name districts name mapping
  ACTUAL_TOSHORTNAME = {
    'TVM': 'Thiruvananthapuram',
    'KLM': 'Kollam',
    'ALP': 'Alappuzha',
    'PTA': 'Pathanamthitta',
    'KTM': 'Kottayam',
    'IDK': 'Idukki',
    'EKM': 'Ernakulam',
    'TSR': 'Thrissur',
    'MPM': 'Malappuram',
    'PKD': 'Palakkad',
    'KKD': 'Kozhikode',
    'WYD': 'Wayanad',
    'KNR': 'Kannur',
    'KGD': 'Kasaragod'
  };

  DISTRICT_ORDER_NAME = ['TVM', 'KLM', 'PTA', 'ALP', 'KTM', 'IDK', 'EKM', 'TSR', 'PKD', 'MPM', 'KKD', 'WYD', 'KNR', 'KGD'];

  DISTRICT_ORDER_ACTUAL_NAME =
    [
      'Thiruvananthapuram',
      'Kollam',
      'Pathanamthitta',
      'Alappuzha',
      'Kottayam',
      'Idukki',
      'Ernakulam',
      'Thrissur',
      'Palakkad',
      'Malappuram',
      'Kozhikode',
      'Wayanad',
      'Mahe',
      'Kannur',
      'Kasaragod'
    ];

  boldColumns = {
    RAINFALL: ['actual', 'normal', 'deviation']
  };

  chartOptions = {
    ['rfHome']: {
      component: 'rfHome',
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      colors: [],
      title: {
        text: 'Deviation from Normal (%)',
        align: 'center',
        margin: 0,
        style: {
          fontSize: '1.2em'
        }
      },
      chart: {
        // height : '210px',
        reflow: true
      },
      xAxis: {
        categories: [],
        labels: {
          autoRotation: false,
          useHTML: true,
          formatter() {
            let label = this.value;
            let title = this.value;
            let style = `transform: rotate(-60deg);font-size:7px;font-weight:600`; // <- YOUR OWN STYLE
            return `<div style="${style}" title="${title}">${label}</div>`;
          },
        }
      },
      yAxis: {
        tickInterval: 20,
        gridLineWidth: 0,
        title: {
          text: ''
        }
      },
      // tooltip: {
      //   valueSuffix: " %",
      //   valueDecimals: 1,
      //   backgroundColor: "#FFF",
      //   opacity:1
      // },
      tooltip: {
        borderWidth: 2,
        borderRadius: 2,
        opacity: 1,
        shadow: false,
        useHTML: true,
        percentageDecimals: 1,
        backgroundColor: '#FFF',
        padding: '0',
        formatter: function () {
          return '<div class="tooltop" >' + this.point.name + '<br>' + 'Deviation: ' + this.point.y + '%' + '</div>';
        }
      },
      legend: {
        useHTML: true,
        width: '100%',
        itemDistance: 4,
        labelFormatter: function () {
          return '<span class="abc" title="' + this.userOptions.fullName + '">' + this.name + '</span>';
        }
      },
      plotOptions: {
        column: {
          pointPadding: 0,
          borderWidth: 0,
          grouping: false
        }
      },
      series: [{
        name: 'Deviation',
        type: 'column',
        data: [],
        color: '#62DF5E',
        showInLegend: false,
        colorByPoint: true,
      },
      {
        name: 'L.E',
        color: '#0099ff',
        data: [],
        showInLegend: true,
        fullName: 'Large Excess',
        type: 'column',
      },
      {
        name: 'E',
        color: '#b9e5fb',
        data: [],
        showInLegend: true,
        fullName: 'Excess',
        type: 'column',
      }, {
        name: 'N',
        color: '#90ed7d',
        data: [],
        showInLegend: true,
        fullName: 'Normal',
        type: 'column',
      },
      {
        name: 'D',
        color: '#e9e910',
        data: [],
        showInLegend: true,
        fullName: 'Deficient',
        type: 'column',
      },
      {
        name: 'L.D',
        color: '#e80d0d',
        data: [],
        showInLegend: true,
        fullName: 'Large Deficient',
        type: 'column',

      }
      ]
    },
    ['rfDonut']: {
      component: 'rfDonut',
      chart: {
        plotBorderWidth: null,
        plotShadow: false,
        height: '380px',
        options3d: {
          enabled: true,
          alpha: 45
        }
      },
      plotOptions: {
        pie: {
          shadow: false,
          innerSize: 100,
          depth: 45,
          center: ['50%', '50%'],
          size: '100%',
          // innerSize: '50%',
          colorByPoint: true,
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        },
      },
      credits: {
        enabled: false
      },
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        }
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      tooltip: {
        valueDecimals: 1,
        pointFormat: '<b>{point.percentage:.1f}%</b>'
      },
      colors: [
        // '#90ed7d',
        // '#b9e5fb',
        // "#e9e910",
        // "#0099ff",
        // '#e80d0d'
        '#0099ff',
        '#b9e5fb',
        '#90ed7d',
        '#e9e910',
        '#e80d0d'
      ],
      series: [{
        type: 'pie',
        data: [],
      },]
    },

    ['riverpoint']: {
      component: 'riverpoint',
      credits: {
        enabled: false
      },
      chart: {
        height: '380px',
      },

      //   tooltip: {
      //     backgroundColor: '#FCFFC5',
      //     borderColor: 'black',
      //     borderRadius: 10,
      //     borderWidth: 3
      // },
      // plotOptions: {
      //   column: {
      //     // colorByPoint: true
      //   }
      // },
      // colors: [],
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        }
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      tooltip: {
        shape: 'square',
        headerShape: 'callout',
        borderWidth: 0,
        shadow: false,
        enabled: true,
        split: true,
        shared: true,
        useHTML: true,
        valueDecimals: 1,
        // valueSuffix: ' mm',
        positioner: function (width, height, point) {
          let chart = this.chart;
          let position;
          if (point.isHeader) {
            position = {
              x: Math.max(
                // Left side limit
                chart.plotLeft,
                Math.min(
                  point.plotX + chart.plotLeft - width / 2,
                  // Right side limit
                  chart.chartWidth - width - chart.marginRight
                )
              ),
              y: point.plotY
            };
          } else {
            position = {
              x: point.series.chart.plotLeft,
              y: point.series.yAxis.top - chart.plotTop
            };
          }
          return position;
        }
      },
      series: []
    },

    ['rfTop']: {
      component: 'rfTop',
      credits: {
        enabled: false
      },
      chart: {
        height: '380px',
        options3d: {
          enabled: true,
          alpha: 15,
          beta: 15,
          depth: 50,
          viewDistance: 25
        }
      },
      plotOptions: {
        column: {
          // colorByPoint: true,
          depth: 25,
          grouping: false
        }
        //   column: {
        //     pointPadding: 0,
        //     borderWidth: 0,
        //     grouping: false
        //  }
      },
      colors: [],
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        }
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: '',
        }
      },
      tooltip: {
        valueSuffix: ' %',
        valueDecimals: 1
      },
      series: [{
        name: 'Deviation',
        type: 'column',
        color: '#66bb6a',
        data: [],
        showInLegend: false,
        // dataLabels: [{
        //   enabled: false
        // }]
        colorByPoint: true,

      },
      {
        name: 'L.Excess',
        color: '#0099ff',
        data: [],
        showInLegend: true,
        fullName: 'Large Excess',
        type: 'column',

      },
      {
        name: 'Excess',
        color: '#b9e5fb',
        data: [],
        showInLegend: true,
        fullName: 'Excess',
        type: 'column',

      },
      {
        name: 'Normal',
        color: '#90ed7d',
        data: [],
        showInLegend: true,
        fullName: 'Normal',
        type: 'column',

      },
      {
        name: 'Deficient',
        color: '#e9e910',
        data: [],
        showInLegend: true,
        fullName: 'Deficient',
        type: 'column',

      },
      {
        name: 'L.Deficient',
        color: '#e80d0d',
        data: [],
        showInLegend: true,
        fullName: 'Large Deficient',
        type: 'column',

      }
      ]
    },

    ['rfBottom']: {
      component: 'rfBottom',
      credits: {
        enabled: false
      },
      chart: {
        height: '380px',
        options3d: {
          enabled: true,
          alpha: 15,
          beta: 15,
          depth: 50,
          viewDistance: 25
        }
      },
      plotOptions: {
        column: {
          // colorByPoint: true,
          depth: 25,
          grouping: false
        }
      },
      colors: [],
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        }
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      tooltip: {
        valueSuffix: ' %',
        valueDecimals: 1
      },
      series: [{
        name: 'Deviation',
        type: 'column',
        color: '#66bb6a',
        data: [],
        showInLegend: false,
        // dataLabels: [{
        //   enabled: false
        // }]
        colorByPoint: true,

      },
      {
        name: 'L.Excess',
        color: '#0099ff',
        data: [],
        showInLegend: true,
        fullName: 'Large Excess',
        type: 'column',

      },
      {
        name: 'Excess',
        color: '#b9e5fb',
        data: [],
        showInLegend: true,
        fullName: 'Excess',
        type: 'column',

      },
      {
        name: 'Normal',
        color: '#90ed7d',
        data: [],
        showInLegend: true,
        fullName: 'Normal',
        type: 'column',

      },
      {
        name: 'Deficient',
        color: '#e9e910',
        data: [],
        showInLegend: true,
        fullName: 'Deficient',
        type: 'column',

      },
      {
        name: 'L.Deficient',
        color: '#e80d0d',
        data: [],
        showInLegend: true,
        fullName: 'Large Deficient',
        type: 'column',

      }
      ]
    },
    ['fcTop']: {
      component: 'fcTop',
      credits: {
        enabled: false
      },
      chart: {
        height: '380px',
      },
      // plotOptions: {
      //   column: {
      //     colorByPoint: true
      //   }
      // },
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        }
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      tooltip: {
        valueSuffix: ' mm ',
        valueDecimals: 1
      },
      series: [{
        name: 'Cumulative Rainfall (mm)',
        showInLegend: true,
        type: 'column',
        color: '#66bb6a',
        data: [],
        dataLabels: [{
          enabled: false
        }]
      },]
    },

    ['fcBottom']: {
      component: 'fcBottom',
      credits: {
        enabled: false
      },
      chart: {
        height: '380px',
      },
      // plotOptions: {
      //   column: {
      //     colorByPoint: true
      //   }
      // },
      // colors: [],
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        }
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      tooltip: {
        valueSuffix: ' mm ',
        valueDecimals: 1
      },
      series: [{
        name: 'Cumulative Rainfall (mm)',
        showInLegend: true,
        type: 'column',
        color: '#66bb6a',
        data: [],
        dataLabels: [{
          enabled: false
        }]
      },]
    },


    ['temperatureBottom']: {
      component: 'temperatureBottom',
      credits: {
        enabled: false
      },
      chart: {
        height: '380px',
        options3d: {
          enabled: true,
          alpha: 15,
          beta: 15,
          depth: 50,
          viewDistance: 25
        }
      },
      plotOptions: {
        column: {
          //  colorByPoint: true,
          grouping: false
        }
      },
      colors: [],
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        }
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      tooltip: {
        valueSuffix: ' °C',
        valueDecimals: 1
      },
      series: [{
        name: 'Temperature',
        type: 'column',
        color: '#66bb6a',
        data: [],
        showInLegend: false,
        // dataLabels: [{
        //   enabled: false
        // }]
        colorByPoint: true,
      },
      {
        name: '< 0',
        color: '#00167B',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '0-5',
        color: '#001B95',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '5-10',
        color: '#0C41BB',
        showInLegend: true,
        data: [],
        type: 'column',
      }, {
        name: '10-15',
        color: '#1265A9',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '15-20',
        color: '#188E93',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '20-25',
        color: '#81BA63',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '25-28',
        color: '#CCC24F',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '28-31',
        color: '#FFBB38',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '31-34',
        color: '#FF9E20',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '34-37',
        color: '#FF800E',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '37-40',
        color: '#FD5F0D',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '40-43',
        color: '#FF3F0A',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '43-46',
        color: '#DF2108',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '>46',
        color: '#AD1919',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      ]
    },

    ['temperatureTop']: {
      component: 'temperatureTop',
      credits: {
        enabled: false
      },
      chart: {
        height: '380px',
        options3d: {
          enabled: true,
          alpha: 15,
          beta: 15,
          depth: 50,
          viewDistance: 25
        }
      },
      plotOptions: {
        column: {
          //  colorByPoint: true
          grouping: false
        }
      },
      colors: [],
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        }
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      tooltip: {
        valueSuffix: ' °C',
        valueDecimals: 1
      },
      series: [{
        name: 'Temperature',
        type: 'column',
        color: '#66bb6a',
        data: [],
        showInLegend: false,
        // dataLabels: [{
        //   enabled: false
        // }]
        colorByPoint: true,
      },
      {
        name: '< 0',
        color: '#00167B',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '0-5',
        color: '#001B95',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '5-10',
        color: '#0C41BB',
        showInLegend: true,
        data: [],
        type: 'column',
      }, {
        name: '10-15',
        color: '#1265A9',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '15-20',
        color: '#188E93',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '20-25',
        color: '#81BA63',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '25-28',
        color: '#CCC24F',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '28-31',
        color: '#FFBB38',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '31-34',
        color: '#FF9E20',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '34-37',
        color: '#FF800E',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '37-40',
        color: '#FD5F0D',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '40-43',
        color: '#FF3F0A',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '43-46',
        color: '#DF2108',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      {
        name: '>46',
        color: '#AD1919',
        showInLegend: true,
        data: [],
        type: 'column',
      },
      ],

    },

    ['temperatureDonut']: {
      component: 'temperatureDonut',
      chart: {
        plotBorderWidth: null,
        plotShadow: false,
        height: '380px',
        options3d: {
          enabled: true,
          alpha: 45
        }
      },
      plotOptions: {
        pie: {
          shadow: false,
          innerSize: 100,
          depth: 45,
          center: ['50%', '50%'],
          size: '100%',
          // innerSize: '50%',
          colorByPoint: true,
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        },
      },
      credits: {
        enabled: false
      },
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        }
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      tooltip: {
        valueDecimals: 1,
        pointFormat: '<b>{point.percentage:.1f}%</b>'
      },
      colors: [
        // '#0099ff',
        // '#b9e5fb',
        // '#90ed7d',
        // '#e9e910',
        // '#e80d0d'
        '#00167B',
        '#001B95',
        '#0C41BB',
        '#1265A9',
        '#188E93',
        '#81BA63',
        '#CCC24F',
        '#FFBB38',
        '#FF9E20',
        '#FF800E',
        '#FD5F0D',
        '#FF3F0A',
        '#DF2108',
        '#AD1919'
      ],
      series: [{
        type: 'pie',
        data: [],
      },]
    },

    ['reservoirNormal']: {
      component: 'reservoirNormal',
      credits: {
        enabled: false
      },
      exporting: {
        enabled: true
      },
      chart: {
        type: 'column',
        height: '380px',
      },
      plotOptions: {
        column: {
          stacking: 'normal'
        },
        line: {
          marker: {
            enabled: false
          }
        }
      },
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        }
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: 'MCM'
        },
      },
      tooltip: {
        valueSuffix: ' MCM',
        valueDecimals: 1
      },
      series: [{
        name: 'Live Storage',
        data: [],
        stack: '1',
        color: '#2D99FF'
      }, {
        name: 'Flood Cushion',
        data: [],
        stack: '2',
        color: '#2CD9C5'
      }, {
        name: 'Gross Storage Capacity',
        data: [],
        color: '#FF6C40',
        type: 'line',
        pointRadius: 0,
      }]
    },

    ['reservoirTop']: {
      component: 'reservoirTop',
      exporting: {
        enabled: true
      },
      credits: {
        enabled: false
      },
      chart: {
        type: 'column',
        height: '380px',
      },
      plotOptions: {
        series: {
          minPointLength: 10,
        },
        column: {
          stacking: 'normal'
        },
        line: {
          marker: {
            enabled: false
          }
        }
      },
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        }
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: 'Percentage Fill %'
        }
      },
      tooltip: {
        valueSuffix: ' %',
        valueDecimals: 1
      },
      series: [{
        name: '',
        id: 'NYearAvgSameDate',
        data: [],
        stack: '1',
        color: '#2D99FF'
      }, {
        name: '',
        id: 'SelectedDate',
        data: [],
        stack: '2',
        color: '#2CD9C5'
      }, {
        name: '',
        id: 'PreviousYearSameDate',
        data: [],
        color: '#FF6C40',
      }]
    },

    ['reservoirBottom']: {
      component: 'reservoirBottom',
      credits: {
        enabled: false
      },
      exporting: {
        enabled: true
      },
      chart: {
        type: 'column',
        height: '380px',
      },
      plotOptions: {
        series: {
          minPointLength: 10,
        },
        column: {
          stacking: 'normal'
        },
        line: {
          marker: {
            enabled: false
          }
        }
      },
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        }
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: 'Percentage Fill %'
        }
      },
      tooltip: {
        valueSuffix: ' %',
        valueDecimals: 1
      },
      series: [{
        name: '',
        id: 'NYearAvgSameDate',
        data: [],
        stack: '1',
        color: '#2D99FF'
      }, {
        name: '',
        id: 'SelectedDate',
        data: [],
        stack: '2',
        color: '#2CD9C5'
      }, {
        name: '',
        id: 'PreviousYearSameDate',
        data: [],
        color: '#FF6C40',
      }]
    },

    ['reservoirDonut']: {
      component: 'reservoirDonut',
      exporting: {
        enabled: false
      },
      chart: {
        plotBorderWidth: null,
        plotShadow: false,
      },
      plotOptions: {
        pie: {
          shadow: false,
          center: ['50%', '50%'],
          size: '100%',
          innerSize: '50%',
          colorByPoint: true,
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        },
      },
      credits: {
        enabled: false
      },
      title: {
        verticalAlign: 'middle',
        text: '',
        style: {
          fontSize: '1em'
        },
        y: -8
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      tooltip: {
        valueDecimals: 1,
        pointFormat: '<b>{point.percentage:.1f}%</b>'
      },
      colors: [
        '#2D99FF',
        '#2CD9C5',
        '#FF6C40',
        '#717B85'
      ],
      series: [{
        type: 'pie',
        data: [],
      },]
    },
    ['reservoirFunnel']: {
      component: 'reservoirFunnel',
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      lang: {
        thousandsSep: ','
      },
      chart: {
        type: 'funnel',
        events: {
          load: function () {
            var chart = this;
            Highcharts.each(chart.series[0].data, function (p, i) {
              p.dataLabel.attr({
                x: (chart.plotWidth - chart.plotLeft) / 2.1, y: (chart.plotWidth - chart.plotLeft) / 8,
                'text-anchor': 'middle'
              });
            });
          },
          redraw: function () {
            var chart = this;
            Highcharts.each(chart.series[0].data, function (p, i) {
              p.dataLabel.attr({
                x: (chart.plotWidth - chart.plotLeft) / 2.1, y: (chart.plotWidth - chart.plotLeft) / 8,
                'text-anchor': 'middle'
              });
            });
          }
        },
        options3d: {
          enabled: true,
          alpha: 10,
          depth: 50,
          viewDistance: 50
        }
      },
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        },
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      tooltip: {
        //pointFormat: '<b>{point.y:,.0f}</b> MCM',
        formatter: function () {
          if (this.key === 'Flood Cushion') {
            let sum = 0;
            this.series.yData.forEach(element => {
              sum = sum + element;
            });
            //for displaying percentage for FC in tooltip
            let perc = this.series.yData[0] / (this.series.yData[0] + this.series.yData[1]) * 100;
            return '<div><span>' + this.point.name + '</span><br><center><b>' + this.y.toFixed(0) + '</b> MCM</center></div>';
          } else {
            return '<div><span>' + this.point.name + '</span><br><center><b>' + this.y.toFixed(0) + '</b> MCM</center></div>';
          }
        },
        shared: true
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            align: 'center',
            formatter: function () {
              let sum = 0;
              this.series.yData.forEach(element => {
                sum = sum + element;
              });
              let perc = this.series.yData[0] / (this.series.yData[0] + this.series.yData[1]) * 100;
              if (this.key === 'Flood Cushion')
                return '<div><span>Flood<br>Cushion<br></span><span> (' + perc.toFixed(0) + '%)</span></div>';
              else {
                // return '<span>' + this.point.name + '</span>';
                return '';
              }
            },
            softConnector: true,
            style: {
              fontSize: '1em',
              color: '#333333',
              textOutline: 'none',
              fontWeight: 300,

            },
          },
          center: ['50%', '50%'],
          neckWidth: '30%',
          neckHeight: '0%',
          width: '80%'
        },
        funnel: {
          states: {
            hover: {
              brightness: 0.2
            }
          }
        }
      },
      legend: {
        useHTML: true,
        width: '100%',
        labelFormatter: function () {
          return '<span class="abc" title="' + this.userOptions.fullName + '">' + this.name + '</span>';
        },
        itemDistance: 3,
        itemStyle: {
          // "color": "#333333",
          // "cursor": "pointer",
          //"fontSize": "5px",
          // "fontWeight": "bold",
          //"textOverflow": "ellipsis"
        }
      },
      responsive: {
        rules: [{
          condition: {
            maxWidth: 300
          },
          chartOptions: {
            plotOptions: {
              series: {
                dataLabels: {
                  inside: true
                },
                center: ['50%', '50%'],
                width: '90%'
              }
            }
          }
        }]
      },
      series: [{
        data: [],
        colors: [
          '#FF8F6D',
          '#2D99FF',
          '#FFE700'
        ],
        showInLegend: false,
        funnel: {
          states: {
            hover: {
              brightness: 1
            }
          },
        }
      },
        // {
        //   type : 'bar',
        //   name: 'Flood Cushion',
        //   color : '#FF8F6D',
        //   showInLegend: true,
        //   fullName: 'Flood Cushion'
        // },
        // {
        //   type : 'bar',
        //   name: 'Live Stg.',
        //   color : '#2D99FF',
        //   showInLegend: true,
        //   fullName: 'Live Storage'
        // },
        // {
        //   type : 'bar',
        //   name: 'Dead Stg.',
        //   color : '#FFE700',
        //   showInLegend: true,
        //   fullName: 'Dead Storage'
        // },
      ]
    },
    ['rfStack']: {
      component: 'rfStack',
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      chart: {
        type: 'column'
      },
      colors: [
        '#0099ff',
        '#b9e5fb',
        '#90ed7d',
        '#e9e910',
        '#e80d0d'
      ],
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        },
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: ''
        },
        stackLabels: {
          enabled: false,
          style: {
            fontWeight: 'bold',
            // color: ( // theme
            //     Highcharts.defaultOptions.title.style &&
            //     Highcharts.defaultOptions.title.style.color
            // ) || 'gray'
          }
        }
      },
      legend: {
        // 'Large Excess': '#0099ff',
        // 'Excess': '#b9e5fb',
        // 'Normal' : '#90ed7d',
        // 'Deficient':'#e9e910',
        // 'Large Deficient': '#e80d0d'
        // align: 'right',
        // x: -30,
        // verticalAlign: 'bottom',
        // y: 25,
        // floating: true,
        // backgroundColor:
        //     Highcharts.defaultOptions.legend.backgroundColor || 'white',
        // borderColor: '#CCC',
        // borderWidth: 1,
        // shadow: false
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '<span style="color:#000">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
        shared: true,
        //   borderWidth: 2,
        //   borderRadius: 2,
        opacity: 1,
        //   shadow: false,
        //   useHTML: true,
        //   percentageDecimals: 1,
        backgroundColor: '#FFF',
        //  padding:'0',
        //   formatter: function () {
        //     return '<span style="color:{series.color}">' + series.name + '</span>' + : <b>{point.y}</b> ({point.percentage:.0f}%)<br/>';
        // }
      },
      plotOptions: {
        column: {
          stacking: 'percent',
          dataLabels: {
            enabled: false
          },
          // colorByPoint: true,
        },

      },
      //   responsive: {
      //     rules: [{
      //         condition: {
      //             maxWidth: 500
      //         },
      //         chartOptions: {
      //             plotOptions: {
      //                 series: {
      //                     dataLabels: {
      //                         inside: true
      //                     },
      //                     // center: ['50%', '50%'],
      //                     width: '100%'
      //                 }
      //             }
      //         }
      //     }]
      // },
      series: []
    },
    // temperature stack bar chart options
    ['tempStack']: {
      component: 'tempStack',
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      chart: {
        type: 'column'
      },
      colors: [
        '#0099ff',
        '#b9e5fb',
        '#90ed7d',
        '#e9e910',
        '#e80d0d'
      ],
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        },
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: ''
        },
        stackLabels: {
          enabled: false,
          style: {
            fontWeight: 'bold',
          }
        }
      },
      legend: {
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}',
        opacity: 1,
        backgroundColor: '#FFF',
      },
      plotOptions: {
        // column: {
        //     stacking: 'normal',
        //     dataLabels: {
        //         enabled: false
        //     },
        // },
        column: {
          stacking: 'percent',
          dataLabels: {
            enabled: false
          },
          // colorByPoint: true,
        },

      },
      series: []
    },

    ['riverPointStationLevel']: {
      component: 'riverPointStationLevel',
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      chart: {
        // type: 'column'
      },
      colors: [],
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        },
      },
      xAxis: {
        categories: []
      },
      yAxis: [{ // Primary yAxis
        labels: {
          format: '{value}',
        },
        title: {
          text: 'Discharge (Cumecs)'
        }
      }, { // Secondary yAxis
        title: {
          text: 'Level (m)',
        },
        labels: {
          format: '{value}',
        },
        opposite: true
      }],
      legend: {
      },
      tooltip: {
        shared: true,
      },
      plotOptions: {
        // column: {
        //     stacking: 'normal',
        //     dataLabels: {
        //         enabled: false
        //     },
        // },
        series: {
          pointWidth: 40
        }

      },
      series: []
    },
    ['riverPointRiverChart']: {
      component: 'riverPointRiverChart',
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      chart: {
      },
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        },
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        labels: {
          format: '{value}',
        },
        title: {
          text: 'Discharge (Cumecs)'
        }
      },
      legend: {
      },
      tooltip: {
      },
      plotOptions: {
      },
      series: []
    },

    ['gwDonut']: {
      component: 'gwDonut',
      chart: {
        plotBorderWidth: null,
        plotShadow: false,
        height: '380px',
        options3d: {
          enabled: true,
          alpha: 45
        }
      },
      plotOptions: {
        pie: {
          shadow: false,
          innerSize: 100,
          depth: 45,
          center: ['50%', '50%'],
          size: '100%',
          // innerSize: '50%',
          colorByPoint: true,
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        },
      },
      credits: {
        enabled: false
      },
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        }
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      tooltip: {
        valueDecimals: 1,
        pointFormat: '<b>{point.percentage:.1f}%</b>'
      },
      colors: [
        '#83cffe',
        '#78dbc5',
        '#fee717',
        '#e98a6d',
        '#D4D7D9'
      ],
      series: [{
        type: 'pie',
        data: [],
      },]
    },

    ['gwStack']: {
      component: 'gwStack',
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      chart: {
        type: 'column'
      },
      colors: [
        '#90ed7d',
        '#b9e5fb',
        '#e9e910',
        '#0099ff',
        '#e80d0d'
      ],
      title: {
        text: '',
        style: {
          fontSize: '1.2em'
        },
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        title: {
          text: ''
        },
        stackLabels: {
          enabled: false,
          style: {
            fontWeight: 'bold',
          }
        }
      },
      legend: {
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '<span style="color:#000">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
        shared: true,
        opacity: 1,
        backgroundColor: '#FFF',
      },
      plotOptions: {
        column: {
          stacking: 'percent',
          dataLabels: {
            enabled: false
          },
        },

      },
      series: []
    },

    'gwHome': {
      component: 'gwHome',
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      colors: [],
      title: {
        text: '',
        align: 'center',
        margin: 0,
        style: {
          fontSize: '1.2em'
        }
      },
      chart: {
        // height : '210px',
        reflow: true
      },
      xAxis: {
        categories: [],
        labels: {
          autoRotation: false,
          useHTML: true,
          formatter() {
            let label = this.value;
            let title = this.value;
            let style = `transform: rotate(-60deg);font-size:7px;font-weight:600`; // <- YOUR OWN STYLE
            return `<div style="${style}" title="${title}">${label}</div>`;
          },
        }
      },
      yAxis: {
        // tickInterval: 20,
        gridLineWidth: 0,
        title: {
          text: ''
        }
      },
      // tooltip: {
      //   valueSuffix: " %",
      //   valueDecimals: 1,
      //   backgroundColor: "#FFF",
      //   opacity:1
      // },
      tooltip: {
        borderWidth: 2,
        borderRadius: 2,
        opacity: 1,
        shadow: false,
        useHTML: true,
        valueDecimals: 1,
        backgroundColor: '#FFF',
        padding: '0',
        formatter: function () {
          return '<div class="tooltop" >' + this.point.name + ' : ' + this.point.y.toFixed(1) + ' m' + '</div>';
        }
      },
      legend: {
        useHTML: true,
        width: '100%',
        itemDistance: 4,
        labelFormatter: function () {
          return '<span class="abc" title="' + this.userOptions.fullName + '">' + this.name + '</span>';
        }
      },
      plotOptions: {
        column: {
          pointPadding: 0,
          borderWidth: 0,
          grouping: false
        }
      },
      series: [{
        name: 'Rise/Fall',
        type: 'column',
        data: [],
        showInLegend: false,
        colorByPoint: true,
      }
      ]
    }
  };

  TEMPERATURE_FORECAST_TOP10_PARAMS = {
    'fcTop': {
      'cType': 'DISTRICT',
      'component': 'RAINFALL',
      'pType': 'STATE',
      'forecastLength': '24',
      'pUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'sUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'primarySource': 'IMD_SHORT_RANGE',
      'secondarySource': 'IMD_LONG_RANGE',
      'chartType': 'top',
      'view': 'Admin'
    }
  };



  TEMPERATURE_FORECAST_BOTTOM10_PARAMS = {
    'fcBottom': {
      'cType': 'DISTRICT',
      'component': 'RAINFALL',
      'pType': 'STATE',
      'forecastLength': '24',
      'pUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'sUUID': 'ProjConstants.STATETOUUIDMAPPING[\'ANDHRA PRADESH\']',
      'primarySource': 'IMD_SHORT_RANGE',
      'secondarySource': 'IMD_LONG_RANGE',
      'chartType': 'bottom',
      'view': 'Admin'
    }
  };


  DonutChartLegend = ['L.Excess', 'Excess', 'Normal', 'Deficient', 'L.Deficient'];

  ReservoirFunnelChartLegend = {
    'Flood Cushion': 'Flood Cushion',
    'Current Live Storage': 'Live Storage',
    'Dead Storage': 'Dead Storage',
  };

  TEMPERATURE_COLOR_MAPPING = {
    '<0': '#00167B',
    '0-5': ' #001B95',
    '5-10': '#0C41BB',
    '10-15': '#1265A9',
    '15-20': '#188E93',
    '20-25': '#81BA63',
    '25-28': '#CCC24F',
    '28-31': '#FFBB38',
    '31-34': '#FF9E20',
    '34-37': '#FF800E',
    '37-40': '#FD5F0D',
    '40-43': '#FF3F0A',
    '43-46': '#DF2108',
    '>46': '#AD1919',
    'NODATA': '#505D6F'
  };

  TEMPERATURE_ORDER = [
    '<0',
    '0-5',
    '5-10',
    '10-15',
    '15-20',
    '20-25',
    '25-28',
    '28-31',
    '31-34',
    '34-37',
    '37-40',
    '40-43',
    '43-46',
    '>46',
    'NODATA'
  ];


}
